// Types
import type { ContextualMenuFetchAction } from '@jet-app/music-classical/action-model/contextual-menu/FetchAction';
import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { ContextualMenu } from '~/utils/contextual-menu';

// Utils for Intents
import { makeContextMenuIntent } from '@jet-app/music-classical/intents/context-menu/ContextMenuIntent';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
    contextualMenu: ContextualMenu;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger, contextualMenu } = dependencies;

    const log = logger.loggerFor(
        'jet/action-handlers/contextual-menu-fetch-action',
    );

    jet.onAction(
        'contextualMenuFetchAction',
        async (action: ContextualMenuFetchAction) => {
            log.info('received ContextualMenuFetchAction:', action);

            try {
                if (action.explicitItems) {
                    contextualMenu.setItemsPromise(
                        action.url,
                        Promise.resolve(action.explicitItems),
                    );
                } else {
                    const apiAction = makeContextMenuIntent({
                        url: action.url,
                        actionType: 'fetch',
                    });

                    // Passing the menuItems Promise returned from jet.dispatch to the contextualMenu Util LRU Map
                    contextualMenu.setItemsPromise(
                        action.url,
                        jet.dispatch(apiAction),
                    );
                }

                return 'performed';
            } catch (e) {
                log.error('Contextual Menu Fetch Action Error:', e);
                throw new Error('an error occurred while handling FetchAction');
            }
        },
    );
}
